import { useSelector } from 'react-redux';
import { selectButtonLoaderType } from '../store/selectors/global';

const checkLoader = (type) => {
  const selectedType = useSelector(selectButtonLoaderType);
  return selectedType === type;
};

export default checkLoader;
